import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsFinancialYearPageRoute: InvariantJiraRoute = {
	name: 'arj-settings-financial-year',
	path: '/jira/plans/settings/financial-year',
	exact: true,
};
